module.exports = __webpack_public_path__ + "assets/img/13.061520c2.png";